import React from "react";
import PropTypes from "prop-types";

const Flex = props => (
  <div
    className={props.className}
    style={{ display: "flex", justifyContent: props.justifyContent, alignItems: props.alignItems, ...props.style }}
  >
    {props.children}
  </div>
);

Flex.propTypes = {
  className: PropTypes.string,
  justifyContent: PropTypes.string,
  alignItems: PropTypes.string,
  children: PropTypes.any,
};

export default Flex;
